import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DropdownModule } from './../../../common/dropdown/dropdown.module';
import { SelectDropdownComponent } from './select-dropdown.component';

@NgModule({
  declarations: [SelectDropdownComponent],
  exports: [SelectDropdownComponent],
  imports: [DropdownModule, CommonModule],
})
export class SelectDropdownModule {}
export { SelectDropdownComponent } from './select-dropdown.component';
